module.exports = __webpack_public_path__ + "static/media/ruler.7899e9d5.svg";